import { render, staticRenderFns } from "./InfoAboutDoctor.vue?vue&type=template&id=53457bab&scoped=true&"
import script from "./InfoAboutDoctor.vue?vue&type=script&lang=js&"
export * from "./InfoAboutDoctor.vue?vue&type=script&lang=js&"
import style0 from "./InfoAboutDoctor.vue?vue&type=style&index=0&id=53457bab&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53457bab",
  null
  
)

export default component.exports